/**
 * @generated SignedSource<<49e9ccca6cef7d03f9c4d584eca5466f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingDeetsScreenQuery$variables = Record<PropertyKey, never>;
export type OnboardingDeetsScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingDeetsView_query">;
};
export type OnboardingDeetsScreenQuery = {
  response: OnboardingDeetsScreenQuery$data;
  variables: OnboardingDeetsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingDeetsScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OnboardingDeetsView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OnboardingDeetsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": [
              "SEQUENCE_ASC"
            ]
          }
        ],
        "concreteType": "DeetConnection",
        "kind": "LinkedField",
        "name": "deets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Deet",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOther",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "deets(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "DEET_BY_DEET_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "UserDeetConnection",
            "kind": "LinkedField",
            "name": "userDeets",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserDeet",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deetId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "other",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userDeets(orderBy:[\"DEET_BY_DEET_ID__SEQUENCE_ASC\"])"
          },
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a7779c247c9d02fe784f4d1b8eb01f8",
    "id": null,
    "metadata": {},
    "name": "OnboardingDeetsScreenQuery",
    "operationKind": "query",
    "text": "query OnboardingDeetsScreenQuery {\n  ...OnboardingDeetsView_query\n}\n\nfragment OnboardingDeetsView_query on Query {\n  deets(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n  ...useUserDeets_query\n}\n\nfragment useUserDeets_query on Query {\n  currentUser {\n    userDeets(orderBy: [DEET_BY_DEET_ID__SEQUENCE_ASC]) {\n      nodes {\n        deetId\n        other\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca48e62f9c9bf793af90bb52ce88c910";

export default node;
